import { Fade } from "@material-ui/core";
import React, { useRef, useState, useEffect } from "react";

import { LoadingPanel, Icon } from "../../components";
import { Video, VideoPlayButton, Mask } from "./style";
import { getWebBridge } from "../../utils/webBridge";
import { isAndroid } from "react-device-detect";
import Poster from "./assets/video_poster.png";
import firebaseEvent from "../../utils/firebaseEvent";
interface Props {
  videoPath: string;
  id: string;
  duration: string;
}

const DetailItemVideo = ({ videoPath, id, duration }: Props) => {
  const [isPlay, setIsPlay] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!videoRef.current) return;
    const ref = videoRef.current;
    // autoplay > fail muted play > fail pause
    ref.muted = false;
    ref.autoplay = true;

    ref.play().catch(() => {
      ref.muted = true;
      ref.play().catch(() => {
        ref.pause();
        setIsPlay(false);
      });
    });
  }, [videoRef]);

  // video play time

  const [playTime, setPlayTime] = useState(0);
  const [newLocation, setNewLocation] = useState("");
  const replaceDurationTime = (num: string) => {
    const minSec = Number(num.split(":")[0]) * 60;
    return minSec + Number(num.split(":")[1]);
  };
  // const secConvertMin = (seconds: any) => {
  //   const addZero = (num: number) => {
  //     return num < 10 ? `0${num}` : num;
  //   };
  //   if (seconds < 10) return `00:0${seconds}`;
  //   if (seconds < 60) return `00:${seconds}`;

  //   if (seconds < 60) {
  //     return `00:${addZero(seconds)}`;
  //   } else {
  //     const min = Math.floor(seconds / 60);
  //     const sec = seconds - min * 60;
  //     return `${addZero(min)}:${addZero(sec)}`;
  //   }
  // };
  useEffect(() => {
    setNewLocation(window.location.href);
    const countdown = setInterval(() => {
      setPlayTime(playTime + 1);
    }, 1000);
    if (!isPlay) {
      clearInterval(countdown);
    }

    return () => {
      clearInterval(countdown);
      if (window.location.href !== newLocation && newLocation !== "") {
        // const time = secConvertMin(playTime);
        const secDuration = replaceDurationTime(duration);
        const loop =
          playTime > secDuration ? Math.floor(playTime / secDuration) : 0;
        const jsonParams = {
          P1: id,
          P2: secDuration,
          P3: playTime,
          P4: loop,
        };
        firebaseEvent("detail_preview_video", jsonParams);
      }
    };
    // eslint-disable-next-line
  }, [playTime, isPlay]);

  useEffect(() => {
    if (!isAndroid) return;
    getWebBridge({ name: "pause", callBack: onWebBridgePause });
    getWebBridge({ name: "resume", callBack: onWebBridgeResume });
    // eslint-disable-next-line
  }, []);

  const onWebBridgePause = () => {
    const videoElem = document.getElementsByTagName("video")[0];
    if (!videoElem) return;
    videoElem.muted = true;
  };
  const onWebBridgeResume = () => {
    const videoElem = document.getElementsByTagName("video")[0];
    if (!videoElem) return;
    videoElem.muted = false;
  };

  const onPlay = () => setIsPlay(true);
  const onPause = () => setIsPlay(false);
  const onLoadedData = () => setIsLoading(false);

  const onClickMask = () => {
    if (isPlay) {
      videoRef.current?.pause();
    } else videoRef.current?.play();
  };

  return (
    <React.Fragment>
      <Video
        loop
        playsInline
        ref={videoRef}
        onPlay={onPlay}
        onPause={onPause}
        onLoadedData={onLoadedData}
        poster={Poster}
      >
        <source src={videoPath} type="video/mp4" />
      </Video>

      <Mask onClick={onClickMask}>
        <Fade in={!isPlay}>
          <VideoPlayButton>
            <Icon name="play" size={26} />
          </VideoPlayButton>
        </Fade>
      </Mask>
      <LoadingPanel isOpen={isLoading} position="absolute" backdropInvisible />
    </React.Fragment>
  );
};

export default DetailItemVideo;
